<template>
  <div class="ibox float-e-margins mass-panel failed-builds-panel">
    <div class="ibox-title">
      <h5><i class="fa fa-exclamation-triangle text-danger m-r-xs"></i> Fehlgeschlagene Builds</h5>
      <span class="mass-count-badge mass-count-danger pull-right">{{ failedBuildsAcrossRuns.length }}</span>
    </div>
    <div class="ibox-content p-none">
      <ul v-if="failedBuildsAcrossRuns.length > 0" class="list-group clear-list no-margins failed-builds-list">
        <li v-for="entry in paginatedFailedBuilds" :key="entry.buildId" class="list-group-item failed-build-item">
          <div class="failed-build-content">
            <div class="failed-build-copy">
              <div class="small font-bold failed-build-title">
                {{ entry.appName }}
              </div>
              <div class="failed-build-meta">
                <span class="mass-chip mass-chip-failed">
                  <i :class="entry.failedAtSync ? 'fa fa-refresh' : 'fa fa-cloud'" class="m-r-xs"></i>
                  {{ entry.failedAtSync ? 'Repo Sync' : 'Codemagic' }}
                </span>
                <span class="text-muted">{{ entry.runDate }}</span>
              </div>
            </div>
            <a v-if="entry.codemagicAppId && entry.codemagicBuildId"
               :href="'https://codemagic.io/app/' + entry.codemagicAppId + '/build/' + entry.codemagicBuildId"
               class="btn btn-xs btn-white m-l-xs failed-build-link" target="_blank"
               title="In Codemagic öffnen">
              <i class="fa fa-external-link"></i>
            </a>
          </div>
        </li>
      </ul>
      <div v-if="failedBuildsAcrossRuns.length > 0 && failedTotalPages > 1" class="failed-build-pagination">
        <span class="text-muted small">
          {{
            (failedBuildsPage - 1) * perPageFailed + 1
          }}&ndash;{{ Math.min(failedBuildsPage * perPageFailed, failedBuildsAcrossRuns.length) }}
          von {{ failedBuildsAcrossRuns.length }}
        </span>
        <div class="btn-group">
          <button :disabled="failedBuildsPage === 1" class="btn btn-white btn-xs"
                  @click="setPage(failedBuildsPage - 1)">
            <i class="fa fa-angle-left"></i>
          </button>
          <button v-for="p in failedTotalPages" :key="p"
                  :class="failedBuildsPage === p ? 'btn-primary' : 'btn-white'"
                  class="btn btn-xs"
                  @click="setPage(p)">
            {{ p }}
          </button>
          <button :disabled="failedBuildsPage === failedTotalPages" class="btn btn-white btn-xs"
                  @click="setPage(failedBuildsPage + 1)">
            <i class="fa fa-angle-right"></i>
          </button>
        </div>
      </div>
      <div v-if="failedBuildsAcrossRuns.length === 0" class="mass-empty-state">
        <i class="fa fa-check-circle text-success m-r-xs"></i> Keine fehlgeschlagenen Builds.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    failedBuildsAcrossRuns: {
      type: Array,
      required: true,
    },
    paginatedFailedBuilds: {
      type: Array,
      required: true,
    },
    failedBuildsPage: {
      type: Number,
      required: true,
    },
    failedTotalPages: {
      type: Number,
      required: true,
    },
    perPageFailed: {
      type: Number,
      required: true,
    },
  },
  methods: {
    setPage(page) {
      this.$emit('update-failed-builds-page', page);
    },
  },
};
</script>
